import { apartmentContext } from "@whitespace/gatsby-plugin-smorgasbord-fastapi";
import {
  Loading,
  ErrorMessage,
} from "@whitespace/gatsby-theme-smorgasbord/src/components";
import PropTypes from "prop-types";
import React, { useEffect, useContext, useState, Suspense } from "react";
import { useTranslation } from "react-i18next";

import AptusContext from "../contexts/aptusContext";

import BookingActions from "./BookingActions";
import Calendar from "./Calendar";
import * as defaultStyles from "./Laundry.module.css";

LaundryContent.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string),
};

function LaundryContent({ styles = defaultStyles }) {
  const { error: apartmentContextError } = useContext(apartmentContext);
  const { calendar, groups, groupsError } = useContext(AptusContext);
  const [tabs, setTabs] = useState([]);
  const [currentTab, setCurrentTab] = useState(null);
  const [pending, setPending] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    setPending(true);
    const tabs =
      groups?.reduce((acc, group) => {
        acc[group.id] = {
          label: group.name,
          content: <Calendar groupId={group.id} />,
        };
        return acc;
      }, {}) || {};

    setTabs(tabs);
    setCurrentTab(Object.keys(tabs)[0]);
    if (calendar?.length) {
      setPending(false);
    }
  }, [groups, calendar]);

  if (apartmentContextError) {
    return <ErrorMessage error={t("fastapi.error.noApartments")} />;
  }

  if (groupsError) {
    return <ErrorMessage error={t("noLaundryGroups")} />;
  }

  if (pending) {
    return <Loading />;
  }

  return (
    <>
      <BookingActions />
      <div className={styles.tabs}>
        {Object.entries(tabs).map(([key, value]) => (
          <button
            key={key}
            onClick={() => setCurrentTab(key)}
            disabled={currentTab === key}
          >
            {value.label}
          </button>
        ))}
      </div>
      {tabs && currentTab && tabs[currentTab].content}
    </>
  );
}

export default function Laundry() {
  return (
    <Suspense fallback={<Loading />}>
      <LaundryContent />
    </Suspense>
  );
}
